<template functional>
  <div class="filterbar">
    <div class="filters">
      <slot name="filters"></slot>
    </div>

    <div class="actions">
      <slot name="actions"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class NFilterbar extends Vue {}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;

.filterbar {
  display: flex;
  overflow-y: visible;
  overflow-x: auto;

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
  }
  &:hover {
    &::-webkit-scrollbar-thumb {
      background-color: $notch-color-neutral-sand-300;
    }
  }

  .filters,
  .actions {
    display: flex;
    align-items: center;
    gap: $notch-space-2x;
  }
}
</style>
